module.exports = __webpack_public_path__ + "img/right-arrow-primary-icon.288c7df8.svg";